import { Paper, Typography, TextField, Alert } from '@mui/material'
import type { PRSheet } from '../../../types/salesforce'

export interface PRSummarySectionProps {
  prSheet: PRSheet
  onChange: (field: keyof PRSheet, value: string) => void
  onBlur?: () => void
}

export function PRSummarySection({ prSheet, onChange, onBlur }: PRSummarySectionProps) {
  return (
    <Paper sx={{ p: 3, mb: 3 }}>
      <Typography variant="h6" gutterBottom>
        📝 PRサマリー
      </Typography>

      <Alert severity="info" icon={<span>💡</span>} sx={{ mb: 2 }}>
        About Meや注力エピソードを通してこれまでの取り組みを振り返ってからサマリーに取り掛かりましょう！
      </Alert>

      <TextField
        fullWidth
        multiline
        rows={6}
        label="PRサマリー（~350文字）"
        value={prSheet.PRSummary__c || ''}
        onChange={(e) => onChange('PRSummary__c', e.target.value)}
        onBlur={onBlur}
        slotProps={{ htmlInput: { maxLength: 350 } }}
        helperText={`${(prSheet.PRSummary__c || '').length} / 350文字`}
      />
    </Paper>
  )
}
